import { USER_TOKEN } from '@/constants/global';
import { MemberInfo, UserInfo } from '@/interface/user';
import { getUserInfo, patchInfo, patchUserInfo, logout } from '@/services/user';
import { humpToUnderline } from '@/utils/format';
import { MemberInfoResponse } from '@/services/swagger/data-contracts';
import { RootState } from '.';

export type UserState = {
  userInfo: UserInfo;
  token: string;
  memberInfo: MemberInfo & MemberInfoResponse;
  memberTypeInfo: MemberInfoResponse;
  bindWechatVisible: boolean;
};

export default {
  namespace: 'user',
  state: {
    token: '',
    userInfo: {},
    // 会员相关信息，暂时先从品牌详情授权接口获取，后面考虑让后端通过用户信息接口返回
    memberInfo: {
      // 当前用户是否为会员，该数据暂时从品牌详情授权接口获取
      hasMember: false,
      /** 是否留资 */
      hasLiuZi: false,
      // 用户总订阅次数
      totalCanSubNum: 0,
      // 用户已订阅次数
      alreadySubNum: 0,
      // 用户剩余订阅次数
      canSubBalanceNum: 0,
      //用户留资邮箱
      email: null,
    },
    bindWechatVisible: false,
  },
  reducers: {
    setState(state: any, { type, ...ret }: any) {
      return {
        ...state,
        ...ret,
      };
    },
    setToken(state: UserState, action) {
      localStorage.setItem(USER_TOKEN, action.payload);
      return { ...state, token: action.payload };
    },
    setUserInfo(state: UserState, action) {
      return { ...state, userInfo: action.payload };
    },
    /** 更新全局状态里和用户角色相关的会员信息，涉及的接口有两个，详情页的user_brand_auth和导航栏的member_info接口 */
    setMemberInfo(state: UserState, action) {
      return { ...state, memberInfo: { ...state.memberInfo, ...action.payload } };
    },
    setMemberTypeInfo(state: UserState, action) {
      return { ...state, memberTypeInfo: { ...state.memberTypeInfo, ...action.payload } };
    },
  },
  effects: {
    *getUserInfo(_, { call, put, select }) {
      const { token } = yield select((state: RootState) => state.user);
      if (!token) {
        return;
      }
      const { data } = yield call(getUserInfo);
      const userInfo: any = {};
      data &&
        Object.entries(data).forEach(([key, value]) => {
          userInfo[humpToUnderline(key)] = value;
        });
      userInfo.token = token;
      yield put({
        type: 'setUserInfo',
        payload: userInfo,
      });
    },
    // node更新用户信息
    *patchInfo({ payload }, { call, put }) {
      const { data } = yield call(patchInfo, payload);
      yield put({
        type: 'setToken',
        payload: data.token,
      });
      yield put({
        type: 'setUserInfo',
        payload: data,
      });
    },
    // java留资更新信息
    *patchUserInfo({ payload }, { call, put, select }) {
      const { company, job, accountName, contactName, shopName } = payload;
      let canGetCoupon = false;
      const currentUser = yield select((state: RootState) => state.user.userInfo);
      const { data } = yield call(patchUserInfo, payload);
      const userInfo: any = {};
      data &&
        Object.entries(data).forEach(([key, value]) => {
          userInfo[humpToUnderline(key)] = value;
        });
      if (company && job && currentUser.profile_completed_state !== userInfo.profile_completed_state) {
        canGetCoupon = true;
      }
      if (
        (accountName || contactName || shopName) &&
        currentUser.shop_info_completed_state !== userInfo.shop_info_completed_state
      ) {
        canGetCoupon = true;
      }
      yield put({
        type: 'setUserInfo',
        payload: userInfo,
      });
      return { canGetCoupon };
    },
    *logout(_, { put, call }) {
      yield call(logout);
      localStorage.removeItem(USER_TOKEN);
      yield put({ type: 'setToken', payload: '' });
      yield put({ type: 'setUserInfo', payload: null });
    },
    *fetchBindWechatVisible({ payload }, { put }) {
      yield put({ type: 'setState', bindWechatVisible: payload });
    },
  },
  subscriptions: {
    setup({ dispatch }) {
      if (typeof window !== 'undefined') {
        localStorage.getItem(USER_TOKEN) === 'null' && localStorage.removeItem(USER_TOKEN);
        localStorage.getItem(USER_TOKEN) &&
          localStorage.getItem(USER_TOKEN) !== 'null' &&
          dispatch({ type: 'setToken', payload: localStorage.getItem(USER_TOKEN) });
        dispatch({ type: 'getUserInfo' });
      }
    },
  },
};
